import React from 'react'
import {
    Box,
    Card,
    CardContent,
    Typography,
    makeStyles
} from '@material-ui/core'
import classNames from 'classnames'
import { Tooltip } from '../../root/components/common'
import { getSimCardsBillingDetails } from '../api/sim-cards-api'
import { useQuery } from 'react-query'
import Loader from '../../root/components/common/loader'

export default function SimCardBillingDetails({ locale }) {
    const classes = useStyles()

    const { data, isLoading, isSuccess } = useQuery(
        ['getSimCardsBillingDetails'],
        () => getSimCardsBillingDetails(),
        { refetchOnWindowFocus: false }
    )

    return (
        <Card className={classes.card}>
            {isLoading ? (
                <CardContent className={classes.loaderContent}>
                    <Loader />
                </CardContent>
            ) : (
                <>
                    {isSuccess && (
                        <CardContent className={classes.cardContent}>
                            <Box className={classes.cardItem}>
                                <Typography className={classes.cardText}>
                                    {
                                        locale.simCards.billingDetails
                                            .totalSimCardsText
                                    }
                                    <span className={classes.cardTextItalic}>
                                        {
                                            locale.simCards.billingDetails
                                                .totalSimCardsTextItalic
                                        }
                                    </span>
                                </Typography>
                                <Typography
                                    className={classNames(
                                        classes.cardText,
                                        classes.cardTotalSimCardsText
                                    )}
                                >
                                    {data.totalSimCards}
                                </Typography>
                            </Box>
                            <Tooltip
                                hover
                                wrapperClass={classes.tooltipWrapper}
                                text={
                                    locale.simCards.billingDetails.tooltipText
                                }
                            >
                                <Box
                                    className={classNames(
                                        classes.cardItem,
                                        classes.cardItemTopBorder
                                    )}
                                >
                                    <Typography className={classes.cardText}>
                                        {locale.simCards.billingDetails.billing}
                                    </Typography>
                                    <Box className={classes.billingDetails}>
                                        <Box>
                                            <Typography
                                                className={classes.cardText}
                                            >
                                                {`${data.totalSimCards} x ${data.pricePerSimCard}`}
                                            </Typography>
                                        </Box>
                                        <Box style={{ display: 'flex' }}>
                                            <Typography
                                                className={classes.cardText}
                                            >
                                                {`${data.totalPrice}`}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Tooltip>
                        </CardContent>
                    )}
                </>
            )}
        </Card>
    )
}

const useStyles = makeStyles(theme => ({
    card: { borderRadius: theme.borderRadius10 },
    cardText: {
        color: theme.primary,
        fontWeight: 700
    },
    cardTextItalic: {
        color: theme.primary,
        fontWeight: 400,
        fontStyle: 'italic'
    },
    cardTotalSimCardsText: {
        fontSize: 24
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        alignItems: 'center'
    },
    loaderContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 150,
        width: 150
    },
    cardItem: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    cardItemTopBorder: {
        borderTop: `0.5px solid ${theme.grayLight}`
    },
    billingDetails: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        cursor: 'pointer'
    },
    tooltipWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    }
}))
